import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import Combobox from '@ls/react-combobox-grid';
import { throwError } from '@ls/error-module';
import { exchange } from '@ls/js-fetch';
import { GroupTypeEntity } from 'state/selections/GroupType';
import {
  setGroupType,
  receiveGroups,
  requestGroups
} from 'state/selections/actions';
import { useDispatch, useSelector } from 'react-redux';
import SelectionState from 'state/selections/SelectionState';
import {
  selectSelectedGroupTypeValue,
  selectSelectedAsOfDate
} from 'state/selections/selectors';
import {useDistributionOptions} from '@ls/distribution';

const options = Object.values(GroupTypeEntity).map(({ label, value }) => ({
  label,
  value
}));

const GroupTypeSelector = props => {
  const dispatch = useDispatch();
  const onChange = useCallback(
    groupType => {
      dispatch(setGroupType(groupType));
    },
    [dispatch]
  );

  const selected = useSelector(
    selectSelectedGroupTypeValue(SelectionState.UNCOMMITTED)
  );
  console.log('SELECTED GROUP TYPE ', selected);

  const unCommitedAsOfDate = useSelector(
    selectSelectedAsOfDate(SelectionState.UNCOMMITTED)
  );
  const {distribution} = useDistributionOptions();
  
  React.useEffect(() => {
    const fetchGroups = groupType => {
      dispatch(requestGroups(groupType));
      
      if(groupType === "COMPOSITE" || groupType === "GROUPS") {
        exchange({
          baseURL: process.env.REACT_APP_BASE_URL_ENTITY_ATTRIBUTES,
          url: `Attributes.json`,
          params: {
            entityDates: unCommitedAsOfDate || 'PBD',
            select: 'entityId,name',
            where: groupType === "COMPOSITE" ? `type='COMP'` : `type='GROUP'`

          }
        })
          .then(({ data = [] }) => {
            dispatch(receiveGroups(groupType, data.results));
          })
          .catch(error => {
            dispatch(receiveGroups(groupType, []));
            throwError(error);
          });
      } else {
      exchange({
        baseURL: process.env.REACT_APP_BASE_URL_ENTITY_MAPPING,
        url: `rs/${GroupTypeEntity[selected].emsEndpoint}`,
        params: {
          date: unCommitedAsOfDate || 'PBD',
         // distribution_description: distribution,
        }
      })
        .then(({ data = [] }) => {
          dispatch(receiveGroups(groupType, data));
        })
        .catch(error => {
          dispatch(receiveGroups(groupType, []));
          throwError(error);
        });
    };
  }
    if (selected) {
      fetchGroups(selected);
    }

  }, [selected, dispatch, unCommitedAsOfDate]);
  return (
    <Combobox
      placeholder="Group Types..."
      options={options}
      onChange={onChange}
      value={selected}
      label="Group Type: "
      variation={1}
      gridHeight={200}
    />
  );
};

GroupTypeSelector.propTypes = {
  value: PropTypes.string
};

export default memo(GroupTypeSelector);
